module.exports = __webpack_public_path__ + "static/img/eyes_11.fd85572.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_11.png
// module id = feK7
// module chunks = 0